interface AgentType {
  AgentId: number;
  AgentName: string;
  AgeType: string;
  AgeAddress: string;
  AgeAddress2: string;
  AgeCity: string;
  AgeState: string;
  AgeZip: string;
  AgePhone1: string;
  AgePhone2: string;
}

export default class FindAgent {
  private readonly findAgentResultWrapper;
  private readonly findAgentItem;
  private readonly totalAgentFind;
  private readonly findAgentForm;
  private readonly findAgentFormInput;
  private readonly findAgentFormSubmitButton;
  private readonly waitingForFindAgentResult;
  private readonly endPointUrl = 'https://rest.us.synatic.com/lwccfscdev/webflow-api/agents';
  private readonly noResultWrapper;

  constructor() {
    // Wrapper element that will be containing all agent Items
    this.findAgentResultWrapper = document.querySelector('.find-agent-results-wrapper') as HTMLDivElement;
    // Agent Item Template
    this.findAgentItem = this.findAgentResultWrapper.querySelector('.find-agents-results-item') as HTMLDivElement;
    // Remove Dummy Template
    this.findAgentItem.remove();
    // Template for updating total agent find.
    this.totalAgentFind = document.querySelector('.agent-results-record-total') as HTMLSpanElement;
    // Find Agent Form Element
    this.findAgentForm = document.querySelector('.find-agent-form') as HTMLFormElement;
    // Find Agent Form Input Element
    this.findAgentFormInput = this.findAgentForm.querySelector(`[type="text"]`) as HTMLInputElement;
    // Find Agent Form Submit Button
    this.findAgentFormSubmitButton = this.findAgentForm.querySelector(`[type="submit"]`) as HTMLInputElement;
    // Wrapper Element for waiting to find agent result
    this.waitingForFindAgentResult = document.querySelector('.find-agent-waiitng-text')
      ?.parentElement as HTMLDivElement;
    // Wrapper for no result found
    this.noResultWrapper = document.querySelector('.find-agent-no-results-wrapper') as HTMLDivElement;
    // Listen to Event
    this.listener();
  }

  private listener() {
    // Listen to click event of the submit button
    this.findAgentFormSubmitButton.addEventListener('click', () => {
      if (this.findAgentFormInput.value) {
        //Hide Agent Result Wrapper
        this.findAgentResultWrapper.style.display = 'none';

        // Display The waiting text wrapper while fetching agent result
        this.waitingForFindAgentResult.style.display = 'block';

        // Hide the no result wrapper
        this.noResultWrapper.style.display = 'none';

        // Clear previous agent result
        document.querySelectorAll('.find-agents-results-item').forEach((ele) => {
          ele.remove();
        });

        // Fetch the data and render if any
        this.getAgentData();
      }
    });
  }

  private async getAgentData() {
    const url = new URL(this.endPointUrl);
    url.searchParams.append('searchTerm', this.findAgentFormInput.value);

    const endpoint = url.toString();

    try {
      const response = await await fetch(endpoint);
      const data: AgentType[][] = await response.json();

      const agents = data.flat();

      // Hide The waiting text wrapper while fetching agent result
      this.waitingForFindAgentResult.style.display = 'none';

      // Render result to DOM
      agents.forEach((agent) => {
        // Clone the agent wrapper Element
        const agentCard = this.findAgentItem.cloneNode(true) as HTMLDivElement;

        // Set Agent Name
        const agentName = agentCard.querySelector('.find-agents-results-name') as HTMLDivElement;
        agentName.textContent = agent.AgentName;

        // Set Agent Address
        const agentAddress = agentCard.querySelector('.find-agents-results-address') as HTMLDivElement;
        agentAddress.textContent = agent.AgeAddress;

        // Set Agent Phone Number
        const agentPhone = agentCard.querySelector('.find-agents-results-phone') as HTMLDivElement;
        agentPhone.textContent = agent.AgePhone1;

        //Set Agent Fax Number
        const agentFax = agentCard.querySelector('.find-agents-results-fax') as HTMLDivElement;
        agentFax.textContent = agent.AgePhone2;

        // Append the agent Card to the Agent Wrapper
        this.findAgentResultWrapper.appendChild(agentCard);
      });

      this.totalAgentFind.textContent = agents.length.toString();

      if (agents.length) {
        //Display Agent Result Wrapper
        this.findAgentResultWrapper.style.display = 'block';
      } else {
        this.noResultWrapper.style.display = 'block';
      }
    } catch (err) {
      // Hide The waiting text wrapper while fetching agent result
      this.waitingForFindAgentResult.style.display = 'none';
      // Show the no result wrapper
      this.noResultWrapper.style.display = 'block';
    }
  }
}
